import { useEffect, useState } from 'react';

import { FEATURE_FLAGS } from '../common/context/FlagsContext';
import { useFeatureFlagsValue } from '../common/context/FlagsValueContext';

export function useMfaEnabled() {
  const [mfaEnabled, setMfaEnabled] = useState(false);
  const flagsContext = useFeatureFlagsValue();
  useEffect(() => {
    // TODO: Also check by client id and enable/disable the flag value
    const enabled =
      flagsContext?.flags?.find(v => v?.flagKey === FEATURE_FLAGS.ENABLE_MFA?.toString())?.flagValue ?? false;
    setMfaEnabled(enabled);
  }, [flagsContext]);

  return { mfaEnabled };
}
